import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { FormQuestion, FormQuestionCreateRequest, FormQuestionUpdateRequest } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const formQuestionApi = {
	index: (workspaceId: string, formId: string): Promise<AxiosResult<FormQuestion[]>> => {
		return axiosRequest({
			method: "GET",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/questions`,
		});
	},

	show: (id: string, workspaceId: string, formId: string): Promise<AxiosResult<FormQuestion>> => {
		return axiosRequest({
			method: "GET",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/questions/${id}`,
		});
	},

	create: (workspaceId: string, formId: string, payload: FormQuestionCreateRequest): Promise<AxiosResult<FormQuestion>> => {
		return axiosRequest({
			method: "POST",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/questions`,
			data: payload,
		});
	},

	update: (id: string, workspaceId: string, formId: string, payload: FormQuestionUpdateRequest): Promise<AxiosResult<FormQuestion>> => {
		return axiosRequest({
			method: "PATCH",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/questions/${id}`,
			data: payload,
		});
	},

	delete: (id: string, workspaceId: string, formId: string): Promise<AxiosResult<void>> => {
		return axiosRequest({
			method: "DELETE",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/questions/${id}`,
		});
	},

	restore: (id: string, workspaceId: string, formId: string): Promise<AxiosResult<FormQuestion>> => {
		return axiosRequest({
			method: "PUT",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/questions/${id}/restore`,
		});
	},

	forceDelete: (id: string, workspaceId: string, formId: string): Promise<AxiosResult<void>> => {
		return axiosRequest({
			method: "DELETE",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/questions/${id}/force`,
		});
	},
};
